import { Button, Modal, Table } from "react-bootstrap";

function OrderDetailsModal({ show, handleClose, handlePay, handleDownloadReceipt, order }) {
  let total = 0;
  const canDownloadReceipt = !!handleDownloadReceipt && order?.order_status === 'Pagada';

  return <Modal show={show} onHide={handleClose}>
    <Modal.Header closeButton>
      <Modal.Title>Detalles de la orden: {order?.order_id}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <Table>
        <thead>
          <tr>
            <td>Producto</td>
            <td>Costo</td>
            <td>Cantidad</td>
            <td>Monto</td>
          </tr>
        </thead>
        <tbody>
          {order && order.line_items.map(li => {
            total += li.quantity * li.product_original_price;
            return <tr key={`line-item-${li.line_item_id}`}>
              <td>{li.product.product_name}</td>
              <td>${li.product_original_price}</td>
              <td>{li.quantity}</td>
              <td>${li.quantity * li.product_original_price}</td>
            </tr>
          })}
          <tr>
            <td></td>
            <td></td>
            <td style={{fontWeight: 'bold'}}>Total</td>
            <td style={{fontWeight: 'bold'}}>${total}</td>
          </tr>
        </tbody>
      </Table>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={handleClose}>
        Cerrar
      </Button>
      {canDownloadReceipt && <Button variant="outline-primary" onClick={handleDownloadReceipt}>
        Descargar recibo
      </Button>}
      {handlePay && <Button variant="primary" onClick={handlePay}>
        Pagar
      </Button>}
    </Modal.Footer>
  </Modal>;
}

export default OrderDetailsModal;
